module.exports = __webpack_public_path__ + "img/open_sided_and_attached_to_main_house_with_connected_non_concrete_roof_system.5c788ec0.jpg";